import General from './GeneralUtils';

/**
 * Convert legacy query format to new API query format
 * @param q - Query string in legacy format
 * @returns Array of query conditions for new API
 */
export function convertQtoQuery(q: string) {
  return General.decode(q)?.rules?.map((rule: any) => {
    let operator = rule.operator;
    let value = rule.value;
    
    // Ensure array values are properly handled for 'in' and 'not_in' operators
    if ((operator === 'in' || operator === 'not_in') && !Array.isArray(value)) {
      value = [value];
    }
    
    return {
      field: rule.field,
      operator: operator,
      value: value
    };
  }) || [];
}